// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/AboutMe-image.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/Business-image.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/News-image.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images/Contact-image.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LeftContent_LeftContent__tWVyh {
  width: 50vw;
  overflow: hidden;
  transition: width 0.5s ease-in-out;
  position: relative;
}

.LeftContent_open__JQY7u {
  height: 100vh;
  width: calc(100vw - 240px);
}

.LeftContent_main__J7Psz {
  opacity: 0;
  transition: opacity 0.7s ease-in-out;
  width: calc(100vw - 240px);
  height: 100vh;
  display: flex;
  justify-content: end;
}
.LeftContent_main__J7Psz .LeftContent_title__L4VDA {
  position: absolute;
  top: 47vh;
  left: 22px;
  font-family: "Poppins", sans-serif;
  font-size: 179px;
  line-height: 80%;
  font-weight: 700;
}
.LeftContent_main__J7Psz .LeftContent_title__L4VDA svg {
  width: 40vw;
}
.LeftContent_main__J7Psz .LeftContent_subTitle__4Xftn {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  width: 398px;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  line-height: 150%;
  color: #191114;
  font-weight: 400;
}
.LeftContent_main__J7Psz .LeftContent_bigScreen__pX3Tf {
  margin-left: 16vw;
}
.LeftContent_main__J7Psz .LeftContent_smallScreen__SfLlm {
  margin-left: 10px;
}

.LeftContent_aboutMe__\\+eqIP {
  opacity: 0;
  top: 110px;
  left: 22px;
  transition: opacity 0.7s ease-in-out;
  position: absolute;
}
.LeftContent_aboutMe__\\+eqIP .LeftContent_image__Dzghd {
  height: 55vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: calc(50vw - 48px);
  width: calc(50vw - 48px);
  background-repeat: no-repeat;
}
.LeftContent_aboutMe__\\+eqIP .LeftContent_subTitle__4Xftn {
  display: flex;
  flex-direction: column;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 150%;
  color: #140C0F;
  margin-top: 30px;
  width: 23.3vw;
}

.LeftContent_business__eXj4g {
  opacity: 0;
  top: 110px;
  left: 22px;
  transition: opacity 0.7s ease-in-out;
  position: absolute;
}
.LeftContent_business__eXj4g .LeftContent_image__Dzghd {
  height: 44vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: calc(50vw - 48px);
  width: calc(50vw - 48px);
  background-repeat: no-repeat;
}
.LeftContent_business__eXj4g .LeftContent_subTitle__4Xftn {
  display: flex;
  flex-direction: column;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 150%;
  color: #140C0F;
  margin-top: 23px;
}

.LeftContent_news__YZfJ\\+ {
  opacity: 0;
  top: 110px;
  left: 22px;
  transition: opacity 0.7s ease-in-out;
  position: absolute;
}
.LeftContent_news__YZfJ\\+ .LeftContent_image__Dzghd {
  height: 44vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: calc(50vw - 48px);
  width: calc(50vw - 48px);
  background-repeat: no-repeat;
}
.LeftContent_news__YZfJ\\+ .LeftContent_subTitle__4Xftn {
  display: flex;
  flex-direction: column;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 150%;
  color: #140C0F;
  margin-top: 23px;
}

.LeftContent_contact__noOWH {
  opacity: 0;
  top: 110px;
  left: 22px;
  transition: opacity 0.7s ease-in-out;
  position: absolute;
}
.LeftContent_contact__noOWH img {
  height: 58vh;
}
.LeftContent_contact__noOWH .LeftContent_image__Dzghd {
  height: 58vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 33vw;
  width: 35vw;
  background-repeat: no-repeat;
}
.LeftContent_contact__noOWH .LeftContent_subTitle__4Xftn {
  display: flex;
  flex-direction: column;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 150%;
  color: #140C0F;
  margin-top: 40px;
}

.LeftContent_visible__jKoeR {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/tabs/LeftContent/LeftContent.module.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,gBAAA;EACA,kCC+Be;ED9Bf,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,0BAAA;AADF;;AAIA;EACE,UAAA;EACA,oCCqB0B;EDpB1B,0BAAA;EACA,aAAA;EACA,aAAA;EACA,oBAAA;AADF;AAGE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ECwCF,kCAvBkB;EAwBlB,gBATc;EAUd,gBANc;EAOd,gBAvBW;ADjBb;AAAI;EACE,WAAA;AAEN;AAEE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;ECqFF,gCAjFiB;EAkFjB,eAtEa;EAuEb,iBAjEe;EAkEf,cAxHY;EAyHZ,gBAlFW;ADFb;AADE;EACE,iBAAA;AAGJ;AAAE;EACE,iBAAA;AAEJ;;AAEA;EACE,UAAA;EACA,UAAA;EACA,UAAA;EACA,oCCjB0B;EDkB1B,kBAAA;AACF;AACE;EACE,YAAA;EACA,yDAAA;EACA,kCAAA;EACA,wBAAA;EACA,4BAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;ECmBF,gCA7CiB;EA8CjB,eAtCa;EAuCb,iBA7Be;EA8Bf,cAnFgB;ED+Dd,gBAAA;EACA,aAAA;AAGJ;;AACA;EACE,UAAA;EACA,UAAA;EACA,UAAA;EACA,oCCzC0B;ED0C1B,kBAAA;AAEF;AAAE;EACE,YAAA;EACA,yDAAA;EACA,kCAAA;EACA,wBAAA;EACA,4BAAA;AAEJ;AACE;EACE,aAAA;EACA,sBAAA;ECLF,gCA7CiB;EA8CjB,eAtCa;EAuCb,iBA7Be;EA8Bf,cAnFgB;EDuFd,gBAAA;AAIJ;;AAAA;EACE,UAAA;EACA,UAAA;EACA,UAAA;EACA,oCChE0B;EDiE1B,kBAAA;AAGF;AADE;EACE,YAAA;EACA,yDAAA;EACA,kCAAA;EACA,wBAAA;EACA,4BAAA;AAGJ;AAAE;EACE,aAAA;EACA,sBAAA;EC5BF,gCA7CiB;EA8CjB,eAtCa;EAuCb,iBA7Be;EA8Bf,cAnFgB;ED8Gd,gBAAA;AAKJ;;AADA;EACE,UAAA;EACA,UAAA;EACA,UAAA;EACA,oCCvF0B;EDwF1B,kBAAA;AAIF;AAFE;EAEE,YAAA;AAGJ;AAAE;EACE,YAAA;EACA,yDAAA;EACA,qBAAA;EACA,WAAA;EACA,4BAAA;AAEJ;AACE;EACE,aAAA;EACA,sBAAA;ECxDF,gCA7CiB;EA8CjB,eAtCa;EAuCb,iBA7Be;EA8Bf,cAnFgB;ED0Id,gBAAA;AAIJ;;AAAA;EAEE,UAAA;AAEF","sourcesContent":["@import \"src/styles/variables\";\n\n.LeftContent {\n  width: 50vw;\n  overflow: hidden;\n  transition: $tab-transition;\n  position: relative;\n}\n\n.open {\n  height: 100vh;\n  width: calc(100vw - 240px);\n}\n\n.main {\n  opacity: 0;\n  transition: $left-content-transition-1;\n  width: calc(100vw - 240px);\n  height: 100vh;\n  display: flex;\n  justify-content: end;\n\n  .title {\n    position: absolute;\n    top: 47vh;\n    left: 22px;\n    @include font-title-179;\n\n    svg {\n      width: 40vw;\n    }\n  }\n\n  .subTitle {\n    margin-top: 30px;\n    display: flex;\n    flex-direction: column;\n    width: 398px;\n    @include font-24;\n  }\n\n  .bigScreen {\n    margin-left: calc(50vw - 34vw);\n  }\n\n  .smallScreen {\n    margin-left: 10px;\n  }\n}\n\n.aboutMe {\n  opacity: 0;\n  top: 110px;\n  left: 22px;\n  transition: $left-content-transition-1;\n  position: absolute;\n\n  .image {\n    height: 55vh;\n    background-image: url('../../assets/images/AboutMe-image.png');\n    background-size: calc(50vw - 48px);\n    width: calc(50vw - 48px);\n    background-repeat: no-repeat;\n  }\n\n  .subTitle {\n    display: flex;\n    flex-direction: column;\n    @include font-16;\n    margin-top: 30px;\n    width: 23.3vw;\n  }\n}\n\n.business {\n  opacity: 0;\n  top: 110px;\n  left: 22px;\n  transition: $left-content-transition-1;\n  position: absolute;\n\n  .image {\n    height: calc(100vh - 56vh);\n    background-image: url('../../assets/images/Business-image.png');\n    background-size: calc(50vw - 48px);\n    width: calc(50vw - 48px);\n    background-repeat: no-repeat;\n  }\n\n  .subTitle {\n    display: flex;\n    flex-direction: column;\n    @include font-16;\n    margin-top: 23px;\n  }\n}\n\n.news {\n  opacity: 0;\n  top: 110px;\n  left: 22px;\n  transition: $left-content-transition-1;\n  position: absolute;\n\n  .image {\n    height: calc(100vh - 56vh);\n    background-image: url('../../assets/images/News-image.png');\n    background-size: calc(50vw - 48px);\n    width: calc(50vw - 48px);\n    background-repeat: no-repeat;\n  }\n\n  .subTitle {\n    display: flex;\n    flex-direction: column;\n    @include font-16;\n    margin-top: 23px;\n  }\n}\n\n.contact {\n  opacity: 0;\n  top: 110px;\n  left: 22px;\n  transition: $left-content-transition-1;\n  position: absolute;\n\n  img {\n    //height: calc(100vh - 432px);\n    height: 58vh;\n  }\n\n  .image {\n    height: 58vh;\n    background-image: url('../../assets/images/Contact-image.png');\n    background-size: calc(100vw - 67vw);\n    width: 35vw;\n    background-repeat: no-repeat;\n  }\n\n  .subTitle {\n    display: flex;\n    flex-direction: column;\n    @include font-16;\n    margin-top: 40px;\n  }\n}\n\n.visible {\n  //transition: $left-content-transition-2;\n  opacity: 1;\n}","//tab sizes\n$tab-width: 60px;\n$not-active-tabs-width: 180px;\n\n//fonts colors\n$title-color: #191114;\n$sub-title-color: #140C0F;\n$footer-color: #323433;\n\n//tabs colors\n$aboutUs: #0085FF;\n$Business: #69B4FF;\n$News: #E0FFFF;\n$Contact: #70E072;\n$MessageSent: #A5F2A6;\n\n//def padding\n$mobile-tab-tablet-padding: 112px 24px 30px 24px;\n\n//def tab content styles\n@mixin selectedTablet {\n  cursor: default;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n}\n@mixin closeIcon {\n  position: fixed;\n  right: 30px;\n  top: 28px;\n  z-index: 2;\n}\n\n//transitions\n$tab-transition: width .5s ease-in-out;\n$left-content-transition-1: opacity .7s ease-in-out;\n$left-content-transition-2: opacity 3s ease-in-out;\n\n//fonts values\n$font-family-main: 'Inter', sans-serif;\n$font-family-title: 'Poppins', sans-serif;\n\n$font-w-400: 400;\n$font-w-700: 700;\n\n$font-size-13: 13px;\n$font-size-14: 14px;\n$font-size-16: 16px; //150%\n$font-size-18: 18px; //150%\n$font-size-20: 20px; // 150%\n$font-size-22: 22px;\n$font-size-24: 24px; //150%\n$font-size-32: 32px; //100%\n$font-size-48: 48px; //80%\n\n$font-size-179: 179px; //80%\n\n$font-line-150p: 150%;\n$font-line-100p: 100%;\n$font-line-80p: 80%;\n\n//font variants\n@mixin font-title-179 {\n  font-family: $font-family-title;\n  font-size: $font-size-179;\n  line-height: $font-line-80p;\n  font-weight: $font-w-700;\n}\n\n@mixin font-13 {\n  font-family: $font-family-main;\n  font-size: $font-size-13;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-14 {\n  font-family: $font-family-main;\n  font-size: $font-size-14;\n  line-height: 16px;\n  color: $sub-title-color;\n}\n\n@mixin font-16 {\n  font-family: $font-family-main;\n  font-size: $font-size-16;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-18 {\n  font-family: $font-family-main;\n  font-size: $font-size-18;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-20 {\n  font-family: $font-family-main;\n  font-size: $font-size-20;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-20-title {\n  font-family: $font-family-title;\n  font-size: $font-size-20;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-22 {\n  font-family: $font-family-title;\n  font-size: $font-size-22;\n  line-height: $font-line-80p;\n  color: $sub-title-color;\n}\n\n@mixin font-24 {\n  font-family: $font-family-main;\n  font-size: $font-size-24;\n  line-height: $font-line-150p;\n  color: $title-color;\n  font-weight: $font-w-400;\n}\n\n@mixin font-24-bold {\n  @include font-24;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-title-32 {\n  font-family: $font-family-title;\n  font-size: $font-size-32;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-title-48 {\n  font-family: $font-family-title;\n  font-size: $font-size-48;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"LeftContent": `LeftContent_LeftContent__tWVyh`,
	"open": `LeftContent_open__JQY7u`,
	"main": `LeftContent_main__J7Psz`,
	"title": `LeftContent_title__L4VDA`,
	"subTitle": `LeftContent_subTitle__4Xftn`,
	"bigScreen": `LeftContent_bigScreen__pX3Tf`,
	"smallScreen": `LeftContent_smallScreen__SfLlm`,
	"aboutMe": `LeftContent_aboutMe__+eqIP`,
	"image": `LeftContent_image__Dzghd`,
	"business": `LeftContent_business__eXj4g`,
	"news": `LeftContent_news__YZfJ+`,
	"contact": `LeftContent_contact__noOWH`,
	"visible": `LeftContent_visible__jKoeR`
};
export default ___CSS_LOADER_EXPORT___;
